/**
 * @typedef {Object} Aposta
 * @property {number} code
 * @property {number} value
 * @property {string} date
 * @property {{
 *      game: {
 *          type: number,
 *          name: string
 *      },
 *      value: number,
 *      numbers: string[]
 * }[]} bets
 */

/**
 * @returns {Aposta[]}
 */
export function getFiltredApostas() {
    let localapostas = [];
    // if(localStorage && localStorage.getItem("saved-apostas")){
    //     localapostas = getApostas();
    //     localapostas.map((savedPreticket, i)=>{
    //         let diff = dateDiff(savedPreticket.bilhetes[0].maxDate) >= 0;
    //         if(!diff) deleteAposta(i);
    //     });
    //     localapostas = getApostas();
    // }
    return localapostas || [];
}

export function getApostas() {
    if (localStorage && localStorage.getItem("saved-apostas")) return JSON.parse(localStorage.getItem("saved-apostas"));
    return undefined;
}

/**
 * @param {Aposta[]} newList
 */
export function setApostas(newList) {
    if (localStorage) localStorage.setItem("saved-apostas", JSON.stringify(newList));
}

export function saveAposta(newAposta) {
    const newList = getApostas() || [];
    if(!newList.find((ap) => ap.detail.arrJogo[0].vchETicket === newAposta.detail.arrJogo[0].vchETicket)) {
        newList.unshift(newAposta);
        return setApostas(newList);
    }
}

export function clearApostas() {
    return setApostas([]);
}

export function deleteAposta(index) {
    const newList = getApostas();
    newList.splice(index, 1);
    return setApostas(newList);
}


// WEBPACK FOOTER //
// ./src/utils/getApostas.js